import { includes } from 'lodash'
import { ICPSegments } from 'constants/dealConstants'
import config from 'config'

const CELEBRATE_URL = `${config.CUSTOMER_WEB_URL}/white-glove/completed`

const isICP = (customerSegment) => {
  return includes(ICPSegments, customerSegment)
}

export const makeCelebrateUrl = (customerSegment) => {
  return `${CELEBRATE_URL}?icp=${isICP(customerSegment)}`
}


// WEBPACK FOOTER //
// ./src/layouts/Deal/utils/index.js